<div class="form-header">
	<h2 class="ud-heading-xl">Public Profile</h2>
	<p>Add information about yourself</p>
</div>

<div class="form-container">
	<div *ngIf='success_message' class="alert alert-success mb-md-3">
		{{success_message}}
	</div>

	<div *ngIf='error_message' class="alert alert-success mb-md-3">
		{{error_message}}
	</div>
	<p class="ud-form-label ud-heading-sm">Basics:</p>


	<form [formGroup]="profileForm" (ngSubmit)="onSubmit()">

		<div class="form-item form-group">
			<input type="text" id="f_name" formControlName="f_name" class="form-control" autocomplete="off" required>
			<label for="f_name">First Name</label>
		</div>


		<div class="form-item form-group">
			<input type="text" id="l_name" formControlName="l_name" class="form-control" autocomplete="off" required>
			<label for="l_name">Last Name</label>
		</div>


		<div class="form-item form-group">
			<input type="text" id="u_name" formControlName="u_name" class="form-control" autocomplete="off" required>
			<label for="l_name">User Name</label>
		</div>

		<div class="form-item form-group">
			<input type="text" id="head_line" formControlName="head_line" class="form-control" autocomplete="off"
				required>
			<label for="head_line">Headline</label>
		</div>


		<div class="form-item form-group">
			<textarea id="description" formControlName="description" class="form-control" rows="4" autocomplete="off"
				required></textarea>
			<label for="description">Description</label>
		</div>


		<div class="did-floating-label-content">
			<select id="language" class="did-floating-select form-control"
				onclick="this.setAttribute('value', this.value);" [(ngModel)]="selectedLanguage"
				(change)="onLanguageChange($event)" value="">
				<option value=""></option>
				<option *ngFor="let language of activeLanguages" [value]="language.language_name">{{
					language.language_name }}</option>
			</select>
			<label class="did-floating-label">Select</label>
		</div>


		<button type="submit" class="btn btn-primary">Save</button>
	</form>

</div>